import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Paper, Stack, Text, UnstyledButton } from "@mantine/core";
import { PlusIcon } from '@phosphor-icons/react';
export default function AddNewWordCard(_a) {
    var editingCardId = _a.editingCardId, onAdd = _a.onAdd;
    var isEditing = editingCardId !== null;
    return _jsx(Paper, { withBorder: true, p: "md", radius: "md", style: {
            borderStyle: 'dashed',
            borderWidth: 2,
            minHeight: 160,
            backgroundColor: isEditing
                ? 'var(--mantine-color-gray-1)'
                : 'var(--mantine-color-gray-0)',
            opacity: isEditing ? 0.5 : 1,
            cursor: isEditing ? 'not-allowed' : 'pointer',
        }, children: _jsx(UnstyledButton, { onClick: onAdd, disabled: isEditing, style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: isEditing ? 'not-allowed' : 'pointer',
            }, children: _jsxs(Stack, { align: "center", gap: "xs", children: [_jsx(ActionIcon, { size: "xl", radius: "xl", variant: "light", color: "blue", tabIndex: -1, disabled: isEditing, component: "div", children: _jsx(PlusIcon, { size: 24, weight: "bold" }) }), _jsx(Text, { fw: 600, c: "dimmed", size: "sm", children: "Add Card" })] }) }) });
}
